// @flow

import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { log } from '../../utils/jsUtils';

import ReferralsHeader from './ReferralsHeader';
import ReferralsContent from './ReferralsContent';
import MemberDrawer from '../MemberDrawer/index';
import Box from '@mui/material/Box';

import referralsHomeStyles from './Styles/ReferralsHome.Style';

const ReferralsHome = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const usehandleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={referralsHomeStyles.root}>
      <Helmet>
        <title>Neo | Share</title>
      </Helmet>
      <ReferralsHeader
        mobileOpen={mobileOpen}
        usehandleDrawerToggle={usehandleDrawerToggle}
      />

      <MemberDrawer
        mobileOpen={mobileOpen}
        usehandleDrawerToggle={usehandleDrawerToggle}
      />

      <ReferralsContent />
    </Box>
  );
};

export default ReferralsHome;

